module.exports = __webpack_public_path__ + "static/banner2-345cc4944be98d1a628c3ed17f5efe05.jpg";